const If = ({ test, children }) => (test ? children : false);

export default If;

